export enum OrganisationOverviewStatus {
  UNPUBLISHED = 'UNPUBLISHED',
  PUBLISHED = 'PUBLISHED',
}

export interface OrganisationOverview {
  id: string;
  status: OrganisationOverviewStatus;
}
